import React, { useState, Suspense, useCallback,useEffect } from 'react';
import { Link, NavLink, useLocation,useParams } from 'react-router-dom';
import { BiLogoFacebook } from "react-icons/bi";
import { PiPhoneCall, PiInstagramLogoFill, PiYoutubeLogoFill } from "react-icons/pi";
import { MdAlternateEmail } from "react-icons/md";
import { GrLocation, GrDocumentDownload } from "react-icons/gr";
import { LuHeart } from "react-icons/lu";
import { RiLinkedinFill } from "react-icons/ri";
import { FiArrowUpRight } from "react-icons/fi";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';

import builerLogo from '../../../assets/images/builders/logos/logo2.svg'
import esightLogo from '../../../assets/images/esight-logo-white.png'
import projectLogo1 from '../../../assets/images/builders/projectLogo/logo1.webp'
import projectBannerImg1 from '../../../assets/images/builders/builderProjects/projectBannerImg1.webp'
import projectBannerImg2 from '../../../assets/images/builders/builderProjects/projectBannerImg2.webp'
import projectBannerImg3 from '../../../assets/images/builders/builderProjects/projectBannerImg3.webp'
import projectBannerImg4 from '../../../assets/images/builders/builderProjects/projectBannerImg4.webp'
import axios from 'axios';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { mediaUrl,baseURL } from '../../axiosInterceptor/axiosInterceptorC';

const path = "/keralaplots/";

function BuilderProjectPreview() {
    const { id } = useParams();
    const location = useLocation();

    const isActiveProjects = () => {
        return location.pathname.includes(`/builderProjectList`) || location.pathname.includes(`/builderProject`) ;
    };

    const settings = {
        dots: false,
        infinite: false,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 1024, // Large devices
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 600, // Medium devices
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 480, // Small devices
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
    };

    useEffect(() => {
        fetch_project_by_id()
      }, []); 
      const [projectlogoImg, setProjectLogo] = useState('');
      const [bannerImageUrls,setbannerImageUrls]= useState([]);
      const [ProjectDetails,setProjectDetails]= useState('');

      const[isLoading,setisLoading]=useState(true)
    const fetch_project_by_id = async () => {
        const projectid=id;
        try {
            const response = await axios.post(`${baseURL}/builder/fetch_project_by_id`, {
                projectid: projectid,
            });
            console.log(response.data)
            const projectDetails = response.data.projectDetails[0];
            const logoUrl = mediaUrl+projectDetails.project_logo;
            setProjectLogo(logoUrl)
            setProjectDetails(projectDetails)
            setisLoading(false)
            const bannerImages = response.data.bannerImages;
            const bannerImageUrls = bannerImages.map(image => ({
                id: image.id,
                url: mediaUrl + image.banner_images,
            }));
           setbannerImageUrls(bannerImageUrls)

        } catch (error) {
            console.error(error);
        }
    };

  return (
    <>
        
        <section id="builderProject">
            <div className="container">
                <div className="builderProjectprojectHead">
                    <div className="projectLogo">
                        {projectlogoImg ? (
                                <img src={projectlogoImg} alt="Website Logo" />
                            ) : (
                                <Skeleton width={100} height={50} /> // Placeholder loading effect
                            )}
                    </div>
                </div>
                <div className="builderProjectBanner">
                <>
                {isLoading || !bannerImageUrls?.length ? (
                    <div className="skeleton-slider">
                    {Array.from({ length: 2 }).map((_, index) => (
                        <div className="builderProjectBannerBox" key={index}>
                        <Skeleton height={300} width="100%" />
                        </div>
                    ))}
                    </div>
                ) : (
                    <PhotoProvider>
                    <Slider {...settings}>
                        {bannerImageUrls.map((image, index) => (
                        <div className="builderProjectBannerBox" key={image.id || index}>
                            <PhotoView src={image.url}>
                            <img src={image.url} alt={`Banner Image ${index + 1}`} />
                            </PhotoView>
                        </div>
                        ))}
                    </Slider>
                    </PhotoProvider>
                )}
                </>
                </div>
                <div className="builderProjectDetails">
                    <div className="builderProjectDetailsCol1">
                        <h1>{ProjectDetails.project_name}</h1>
                        <div className="builderProjectDetailsBox">
                            <p>For inquiries :</p>
                            <ul>
                                <li>
                                <a href={`tel:+91${ProjectDetails.phone_number}`}>+91 {ProjectDetails.phone_number}</a>
                                </li>
                                {ProjectDetails.optional_phone_number && (
                                    <li>
                                        <a href={`tel:+91${ProjectDetails.optional_phone_number}`}>
                                        +91 {ProjectDetails.optional_phone_number}
                                        </a>
                                    </li>
                                    )}
                            </ul>
                        </div>
                        {ProjectDetails.ebrochure_pdf && (
                        <div className="builderProjectDetailsBox">
                            <a href={mediaUrl+ProjectDetails.ebrochure_pdf} download="" className="downloadEbrochure"><GrDocumentDownload /> Download E-brochure</a>
                        </div>
                        )}
                    </div>
                    <div className="builderProjectDetailsCol2">
                       
                        
                        <div dangerouslySetInnerHTML={{ __html: ProjectDetails.description_val }} />
                    </div>
                </div>
            </div>
        </section>
        
    </>
  );
}

export default BuilderProjectPreview;
